<script>
	import axiosInstance from "$lib/js/axios.js";
	import { t, locale } from '$lib/translations';

	export let data;
</script>

<a href="/{$locale}/news/{data.page.url}">
	<article class="article">
		<div class="article-wrapper">
			<div class="date-wrapper">
				<div class="date">{new Date(data.timestamp * 1000).toLocaleDateString()}</div>
			</div>
			<div class="image">
				<img src="{axiosInstance.getUri()}/resources/{data.image_small}" alt="{data.title}">
			</div>
			<div class="text">
				<h2 class="title">{data.title}</h2>
				<p class="description">{data.short_description}</p>
			</div>
		</div>
		<div class="more">
			<a href="/news/{data._id}">{$t('home.details')}</a>
		</div>
	</article>
</a>

<style lang="scss">
	@import "/src/lib/scss/main";

	a {
		text-decoration: none;
	}

	.article {
		background-color: #161616;
		border-radius: 8px;
		min-width: 300px;
		max-width: 300px;
		min-height: 400px;
		display: flex;
		flex-direction: column;
		gap: 25px;
		padding: 20px;
		justify-content: space-between;
		transition: background-color $default-transition-time;
		cursor: pointer;
		max-height: 400px;

		& > .article-wrapper {
			display: flex;
			flex-direction: column;
			gap: 25px;
			position: relative;

			& > .date-wrapper {
				display: flex;
				width: 100%;
				justify-content: center;
				position: absolute;
				top: -9%;

				& > .date {
					font-size: 14px;
					line-height: 120%;
					color: #232323;
					font-weight: 600;
					background-image: url(/src/lib/images/date_bg.svg);
					width: min-content;
					padding: 12px;
					background-repeat: no-repeat;
					background-position: center;
					background-size: contain;
				}
			}

			& > .image {
				object-fit: cover;
				width: 100%;

				& > img {
					border-radius: 4px;
				}
			}

			& > .text {
				display: flex;
				flex-direction: column;
				gap: 16px;

				& > .title {
					font-size: 18px;
					line-height: 120%;
					color: #fffbef;
					text-transform: uppercase;
					transition: color $default-transition-time;
					font-weight: 500;
				}

				& > .description {
					color: #FFFBEF;
					font-size: 14px;
					line-height: 120%;
					font-weight: 400;
					text-overflow: ellipsis;
					width: 100%;
					max-height: 120px;
					overflow: hidden;
					word-wrap: break-word;
					transition: color $default-transition-time;
				}
			}
		}

		& > .more {
			text-align: right;

			& > a {
				font-size: 14px;
				line-height: 120%;
				text-align: right;
				color: #fed500;
				text-decoration: none;
				transition: color $default-transition-time;
			}
		}

		&:hover {
			background-color: #fed500;;

			& > .article-wrapper {
				& > .text {

					& > .title {
						color: #232323;
					}
					& > .description {
						color: #232323;
					}
				}
			}
			& > .more {
				& > a {
					color: #232323;
				}
			}
		}
	}

	@media screen and (max-width: 700px) {
		.article {
			min-width: 320px!important;
			max-width: 320px!important;
		}
	}
</style>